import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { Box, makeStyles, Container, Grid, Typography, Divider } from '@material-ui/core';

// import svgs
import car from '/public/svgs/car.svg';
import map from '/public/svgs/map.svg';
import face from '/public/svgs/fb.svg';
import email from '/public/svgs/email.svg';
import phone from '/public/svgs/phone.svg';
import location from '/public/svgs/location.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: 40,
        paddingBottom: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#444b56',
    },
    footerRow: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginTop: 20,
        width: 220,
        margin: 'auto',
        paddingBottom: 30,
    },
    footerRowMiddle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 20,
        width: 240,
        margin: 'auto',
    },
    divider: {
        backgroundColor: 'white',
        marginTop: 22,
        marginBottom: 10,
        height: 1,
        opacity: 0.1,
    },
    line: {
        backgroundColor: 'white',
        marginTop: 8,
        marginBottom: 8,
        height: 1,
        width: 200,
        height: 1,
        opacity: 0.1,
    },
    title: {
        fontSize: 14,
        color: 'white',
        fontWeight: 600,
    },
}));

const Footer = () => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <Container fullWidth={true} maxWidth="lg">
                <Grid container spacing={3}>
                    <Grid item lg={4} sm={12} xl={4} md={4}>
                        <Box className={classes.footerRow}>
                            <Box style={{ display: 'flex' }}>
                                <Typography className={classes.title}>Хаяг</Typography>
                            </Box>
                            <Box className={classes.line}></Box>
                            <Typography
                                variant="body1"
                                style={{ marginTop: 0, color: 'white', opacity: 0.4 }}
                            >
                                Монгол улс, Булган Аймаг, <br />Тэшиг сум Жаргалант 5-р баг, <br />
                                Үйлчилгээний хороо 2-206
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item lg={4} sm={12} xl={4} md={4}>
                        <Box className={classes.footerRow}>
                            <Box style={{ display: 'flex' }}>
                                <Typography className={classes.title}>Холбоо барих</Typography>
                            </Box>
                            <Box className={classes.line}></Box>
                            <Typography
                                variant="body1"
                                style={{ marginTop: 0, color: 'white', opacity: 0.4 }}
                            >
                                70345339,  <br />99992974, 98989592
                                <br />
                                www.teshig.bu.gov.mn
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item lg={4} sm={12} xl={4} md={4}>
                        <Box className={classes.footerRow}>
                            <Box style={{ display: 'flex' }}>
                                <Typography className={classes.title}>Хандалт</Typography>
                            </Box>
                            <Box className={classes.line}></Box>
                            <Typography
                                variant="body1"
                                style={{ marginTop: 0, color: 'white', opacity: 0.4 }}
                            >
                                Өнөөдөр: 1270
                                <br />
                                Энэ 7 хоног: 1270
                                <br />
                                Энэ сар: 34238
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Divider className={classes.divider} />
                <Grid container>
                    <Grid item lg={12} sm={12}>
                        <Box style={{ textAlign: 'center', marginTop: 6 }}>
                            <Typography
                                variant="body1"
                                style={{ marginLeft: 10, color: 'white', opacity: 0.6 }}
                            >
                                © 2022 Булган аймгийн Тэшиг сум --- Developed by ByteLinks llc
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

Footer.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func,
};

export default Footer;
